<template>
  <div class="gallery">
    <section class="banner">
      <div class="container">
        <h1 class="font-weight-bold my-title toUppercase">Cursos ead</h1>
        <h4 class="text-white my-p">Estude agora mesmo sem sair de casa</h4>
      </div>
    </section>
    <section class="content">
      <section class="our-photos">
        <div class="container">
          <div class="text w-75">
            <h2
              style="font-size:20px;"
              class="text-uppercase text-center mt-5 pt-5 font-weight-bold"
            >Por que estudar EAD?</h2>
            <p class="text-center" style="font-size:14px;color:gray;">
              Oferecemos sem fronteiras uma formação continuada totalmente online,  onde a pessoa em qualquer lugar do mundo pode se conectar e adquirir conhecimento constante, unindo a prática e a teoria. Abordagem de casos complexos, descritos nos livros da área e intervenções que deram certo e também o relato das dificuldades fazem parte desse curso.
            </p>
            <p class="text-center" style="font-size:14px;color:gray;">
             Aprender e dividir conhecimentos sobre o que deu e o que não deu certo são os motivadores desta formação continuada.
            </p>
            <p class="text-center" style="font-size:14px;color:gray;">
             Os cursos são ministrados por profissionais com ampla experiência prática e que trazem inovação para nosso segmento sem deixar o conhecimento acadêmico de lado. Se você quer estudar da forma mais dinâmica possível atualmente este é seu lugar.
            </p>
          </div>
          <h1
            style="font-size:20px;color:gray;"
            class="font-weight-bold mb-5 mt-5 d-flex flex-column justify-content-center align-items-center"
          >
            Nossos
            <span style="font-size:26px;" class="text-white">Cursos EAD</span>
          </h1>
          <div class="load text-center" v-show="showLoader">
            <img src="@/assets/images/30.svg" />
          </div>
          <div class="row w-100">
            <!-- <div class="col-md-12">
            <div id="mdb-lightbox-ui"></div>-->

            <!-- <div class="mdb-lightbox"> -->
            <div
              class="col-lg-6 col-12 border-transparent"
              v-for="(item, index) of produtos"
              :key="index"
            >
              <!--       href="https://mdbootstrap.com/img/Photos/Lightbox/Original/img%20(145).jpg"
              data-size="1600x1067"-->
              <div v-if="item.indestaque == true">
                <router-link :to="'/curso/' + item.desurl" class="border-none">
                  <div class="row border-fff">
                    <div class="col-lg-5 col-sm-6 col-12 px-0 py-0 imagemblog">
                      <img :src="item.desarquivo" :alt="item.desarquivo" />
                    </div>
                    <div class="col-lg-7 col-sm-6 col-12 flex j-c-center content-to-post">
                      <div>
                        <h2 class="toCapitalize">{{ item.desproduto }}</h2>
                        <router-link
                          :to="'/curso/' + item.desurl"
                          class="btn btn-outline-primary text-uppercase mt-3"
                        >Saiba mais</router-link>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
              <div v-if="item.indestaque == false">
                <div class="row border-fff">
                  <div class="col-lg-5 col-sm-6 col-12 px-0 py-0 imagemblog">
                    <img :src="item.desarquivo" :alt="item.desarquivo" />
                  </div>
                  <div class="col-lg-7 col-sm-6 col-12 flex j-c-center content-to-post">
                    <div>
                      <h2 class="toCapitalize">{{ item.desproduto }}</h2>
                      <button
                        class="btn btn-outline-primary text-uppercase mt-3 btEmBreve"
                        :disabled="isBtnDisabled"
                      >Em breve</button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <router-link
                :to="'/curso/' + item.desurl"
                class="w-100 d-flex align-items-center"
              >
                <div
                  class="col-lg-5 col-12 imagemblog"
                  :style="'background-image:url(' + item.desarquivo + ');'"
                ></div>
                <div class="col-lg-7 col-12">
                  <h2>{{ item.desproduto }}</h2>
                  <router-link
                    :to="'/curso/' + item.desurl"
                    class="btn btn-outline-primary text-uppercase mt-3"
                    >Saiba mais</router-link
                  >
                </div>
              </router-link>-->
            </div>
          </div>
        </div>
        <!-- </div> -->
      </section>
    </section>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  components: {},
  data() {
    return {
      urlPaginas:
        "https://cms.fastcode.com.br/api/paginas?url=ead",
      pagina: [],
      title: "",
      seotittle: "",
      desc: "",
      key: "",
      produtosUrl: "https://cms.fastcode.com.br/api/produtocategorias/",
      produtos: [],
      showLoader: false,
      token:
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJNREV5VW10R1ZGWkZUazVWZHowOVRXcEJORTFCUFQwIn0=.g4vhbYC9Tw7PSdDLXQsuXeXSaks4Z5SKuIPDXqMug0g=",

      setts: {
        background: "unset"
      },
      isBtnDisabled: true
    };
  },
  mounted() {
    this.pegaProdutos();
    this.seoGet();
    this.$ga.page("/ead");
  },
  methods: {
    pegaProdutos() {
      this.showLoader = true;
      fetch(this.produtosUrl + "1/produtos", {
        method: "get",
        headers: { Authorization: this.token }
      })
        .then(response => response.json())
        .then(response => {
          this.showLoader = false;
          this.produtos = response.data;
        });
    },
    seoGet() {
      fetch(this.urlPaginas, {
        method: "get",
        headers: { Authorization: this.token }
      })
      .then(response => response.json()) // retorna uma promise
      .then(response => {
      this.pagina = response.data;
      this.title = this.pagina.despagina ? this.pagina.despagina : "";
      this.seotittle = this.pagina.destitle ? this.pagina.destitle : "";
      this.desc = this.pagina.desdescription ? this.pagina.desdescription : "";
      this.key = this.pagina.deskeywords ? this.pagina.deskeywords : "";
      this.$emit("updateHead");
      });
    },
  },
  head: {
    title: function() {
      return { inner: this.seotittle };
    },
    link: function() {
      return [
        { rel: "canonical", href: window.location.href, id: "canonical" }
      ];
    }
  }
};
</script>

<style scoped>
.btEmBreve {
  border: solid 2px #fff;
}
img {
  width: 100%;
}
p >>> p {
  color: #fff !important;
}
.content {
  padding: 20px 0 100px !important;
}
</style>
<style scoped lang="scss">
.border-none {
  border: none;
}
.btn-outline-primary {
  color: #fff !important;
}
.btn-outline-primary:hover {
  color: #fff !important;
}
a {
  color: #fff;
  border: solid 2px #fff;
}
a:hover {
  text-decoration: none;
}
h2 {
  color: #fff;
  font-size: 32px;
}
.imagemblog {
  // height: 195px;
  background-size: cover;
  background-position: center center;
}
.gallery {
  width: 100%;
  background-color: #2d2d2d;
  section.banner {
    height: 400px;
    background: url("../assets/images/ead/01.png") no-repeat;
    background-size: cover;

    .container {
      height: 100%;
      display: flex;
      flex-direction: column;
      // align-items: center;
      justify-content: center;
    }
    button {
      width: 200px;
    }
  }
  section.content .our-photos .container {
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  section.content .our-videos {
    height: 350px;
    display: flex;
    flex-direction: column;
    .container {
      align-items: center;
      flex-direction: column;

      iframe {
        width: 100%;
      }
    }
  }
  .container {
    height: 100%;
    display: flex;
  }

  section.content {
    h1 {
      color: #000;
      font-size: 25px;
      font-weight: bold;
    }
  }
}
h1 {
  margin-top: 100px;
}
@media (max-width: 420px) {
  h1 {
    margin-top: 50px;
  }
}
</style>
